import React, { useState } from 'react';
import {
	Alert,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText,
	Button,
} from '@mui/material';
import { apiErrorMessage } from '../../../api/catalog';
import { ModalActions } from '../ConfirmarEliminarDialog/styles';

interface ConfirmarLiberarMateriaDialogProps {
	open: boolean;
	materiaNombre: string;
	onConfirm: () => Promise<void>;
	onCancel: () => void;
}

const ConfirmarLiberarMateriaDialog: React.FC<ConfirmarLiberarMateriaDialogProps> = ({
	open,
	materiaNombre,
	onConfirm,
	onCancel,
}) => {
	const [error, setError] = useState<string | null>(null);
	const [saving, setSaving] = useState(false);

	const handleConfirm = async () => {
		if (saving) return;
		setSaving(true);
		setError(null);
		try {
			await onConfirm();
			setSaving(false);
		} catch (err) {
			setError(apiErrorMessage(err));
			setSaving(false);
		}
	};

	const handleCancel = () => {
		if (saving) return;
		setError(null);
		onCancel();
	};

	return (
		<Dialog open={open} onClose={handleCancel} maxWidth='xs' fullWidth>
			<DialogTitle>Eliminar materia</DialogTitle>
			<DialogContent>
				<DialogContentText>
					¿Eliminar <strong>{materiaNombre}</strong>? Se borran el código, los alumnos
					inscritos y los recursos de esta materia.
				</DialogContentText>
				{error && <Alert severity='error'>{error}</Alert>}
			</DialogContent>
			<ModalActions>
				<Button onClick={handleCancel} disabled={saving}>
					Cancelar
				</Button>
				<Button
					onClick={() => void handleConfirm()}
					color='error'
					variant='contained'
					disabled={saving}
				>
					{saving ? 'Eliminando...' : 'Eliminar'}
				</Button>
			</ModalActions>
		</Dialog>
	);
};

export default ConfirmarLiberarMateriaDialog;
